// Data para el Agenda Builder MVP
// SECTIONS fue migrado a MongoDB (SeccionAgenda) para PersonalizaAgenda.tsx
// Todavía referenciado por AgendaBuilder.tsx (flujo viejo)

export interface Format {
  id: number;
  slug: string; // Slug para match con MongoDB
  name: string;
  description: string;
  pagesPerDay: number;
  totalPages: number;
  basePrice: number;
  imageUrl?: string;
  popular?: boolean;
}

export interface Section {
  id: number;
  name: string;
  category: "productivity" | "wellness" | "creativity" | "finance" | "other";
  description: string;
  pages: number;
  price: number;
  imageUrl?: string;
  icon?: string;
}

export const FORMATS: Format[] = [
  {
    id: 1,
    slug: "agenda-diario-1-pagina",
    name: "Diario 1 Página",
    description:
      "Una página completa por día. Ideal para planificación detallada.",
    pagesPerDay: 1,
    totalPages: 365,
    basePrice: 25.0,
    popular: false,
  },
  {
    id: 2,
    slug: "agenda-diario-2-paginas",
    name: "Diario 2 Páginas",
    description: "Dos páginas por día. Máximo espacio para tus ideas.",
    pagesPerDay: 2,
    totalPages: 730,
    basePrice: 35.0,
    popular: true,
  },
  {
    id: 3,
    slug: "agenda-medio-dia",
    name: "Medio Día",
    description: "Media página por día. Balance perfecto.",
    pagesPerDay: 0.5,
    totalPages: 183,
    basePrice: 20.0,
    popular: false,
  },
  {
    id: 4,
    slug: "agenda-semanal",
    name: "Semanal",
    description: "Una página por semana. Para visión general.",
    pagesPerDay: 0.14,
    totalPages: 52,
    basePrice: 15.0,
    popular: false,
  },
  {
    id: 5,
    slug: "agenda-mensual",
    name: "Mensual",
    description: "Una página por mes. Planificación de alto nivel.",
    pagesPerDay: 0.03,
    totalPages: 12,
    basePrice: 12.0,
    popular: false,
  },
];

export const SECTIONS: Section[] = [
  // PRIORIDAD 1: Plantillas de organización más importantes
  {
    id: 10,
    name: "Organización Diaria",
    category: "productivity",
    description:
      "Páginas de organización para tu día a día (mínimo 120 páginas)",
    pages: 120,
    price: 5.0,
    icon: "📓",
    imageUrl:
      "https://viviconamoryarte-assets.s3.us-east-2.amazonaws.com/images/general/PLANTILLAS+DE+ORGANIZACION+DIARIA.png",
  },
  {
    id: 21,
    name: "Organización Semanal",
    category: "productivity",
    description: "Planificación semanal con vista panorámica de tus 7 días",
    pages: 52,
    price: 4.5,
    icon: "📅",
    imageUrl:
      "https://viviconamoryarte-assets.s3.us-east-2.amazonaws.com/images/general/ORGANIZACION+SEMANA+ESENCIAL.png",
  },
  {
    id: 19,
    name: "Notas Libres",
    category: "creativity",
    description: "Páginas para tus ideas espontáneas",
    pages: 50,
    price: 4.0,
    icon: "📝",
    imageUrl:
      "https://viviconamoryarte-assets.s3.us-east-2.amazonaws.com/images/general/NOTAS+LIBRES+TODAS.png",
  },

  // Productividad & Planificación
  {
    id: 9,
    name: "Calendario Mensual Panorámico",
    category: "productivity",
    description:
      "Vista mensual ampliada para mayor claridad (12 meses + extras)",
    pages: 26,
    price: 4.0,
    icon: "🗓️",
    imageUrl:
      "https://viviconamoryarte-assets.s3.us-east-2.amazonaws.com/images/general/PANORAMICOS+DOS.png",
  },
  {
    id: 4,
    name: "Proyección del Negocio",
    category: "productivity",
    description: "Proyecta el crecimiento y consolidación de tu negocio",
    pages: 3,
    price: 2.5,
    icon: "📊",
    imageUrl:
      "https://viviconamoryarte-assets.s3.us-east-2.amazonaws.com/images/general/PROYECCIONES+JUNTAS.png",
  },
  {
    id: 11,
    name: "Lineamientos de Marca",
    category: "productivity",
    description: "Define y documenta la identidad visual de tu marca",
    pages: 2,
    price: 4.0,
    icon: "🎨",
    imageUrl:
      "https://viviconamoryarte-assets.s3.us-east-2.amazonaws.com/images/general/LINEAMIENTOS+DOS.png",
  },

  // Finanzas
  {
    id: 12,
    name: "Finanzas Personal o Negocio",
    category: "finance",
    description:
      "Registro completo de ingresos, gastos y balance mensual (6 meses)",
    pages: 56,
    price: 5.5,
    icon: "💰",
    imageUrl:
      "https://viviconamoryarte-assets.s3.us-east-2.amazonaws.com/images/general/FINANZAS+TODAS.png",
  },

  // Hogar & Organización
  {
    id: 13,
    name: "Aseo del Hogar",
    category: "other",
    description: "Planificación de limpieza y tareas del hogar",
    pages: 28,
    price: 3.0,
    icon: "🏠",
    imageUrl:
      "https://viviconamoryarte-assets.s3.us-east-2.amazonaws.com/images/general/PLANIFICACION+ASEO+DEL+HOGAR.png",
  },

  // Negocio & Marketing
  {
    id: 14,
    name: "Planificación Semanal de Redes Sociales",
    category: "productivity",
    description: "Organiza tu contenido en redes sociales semanalmente",
    pages: 28,
    price: 3.5,
    icon: "📱",
    imageUrl:
      "https://viviconamoryarte-assets.s3.us-east-2.amazonaws.com/images/general/PLANIFICADOR+SEMANAL+DE+REDES+SOCIALES.png",
  },
  {
    id: 15,
    name: "Plan de Promociones, Fechas Importantes o Nuevo Producto",
    category: "productivity",
    description: "Desarrollo de actividades, lanzamientos y promociones",
    pages: 14,
    price: 3.0,
    icon: "🚀",
    imageUrl:
      "https://viviconamoryarte-assets.s3.us-east-2.amazonaws.com/images/general/DESARROLLO+DE+ACTIVIDAD+O+PRODUCTO+TODAS.png",
  },
  {
    id: 16,
    name: "Registro de Clientes",
    category: "other",
    description: "Base de datos de tus clientes importantes",
    pages: 10,
    price: 2.5,
    icon: "👥",
    imageUrl:
      "https://viviconamoryarte-assets.s3.us-east-2.amazonaws.com/images/general/REGISTRO+DE+CLIENTES.png",
  },
  {
    id: 17,
    name: "Registro de Proveedores",
    category: "other",
    description: "Contactos y datos de tus proveedores",
    pages: 10,
    price: 2.5,
    icon: "🤝",
    imageUrl:
      "https://viviconamoryarte-assets.s3.us-east-2.amazonaws.com/images/general/REGISTRO+DE+PROVEEDORES.png",
  },

  // Bienestar & Creatividad
  {
    id: 18,
    name: "Hojas de Gratitud",
    category: "wellness",
    description: "Espacio diario para reflexionar sobre tus bendiciones",
    pages: 25,
    price: 3.0,
    icon: "🙏",
    imageUrl:
      "https://viviconamoryarte-assets.s3.us-east-2.amazonaws.com/images/general/HOJA+DE+GRATITUD.png",
  },
  {
    id: 20,
    name: "Tablero Borrable",
    category: "productivity",
    description: "Tablero borrable en la portada interna (no suma páginas)",
    pages: 0,
    price: 3.0,
    icon: "🖊️",
    imageUrl:
      "https://viviconamoryarte-assets.s3.us-east-2.amazonaws.com/images/general/item+tableros+borrables.png",
  },
];

export const CATEGORY_LABELS = {
  productivity: "Productividad",
  wellness: "Bienestar",
  creativity: "Creatividad",
  finance: "Finanzas",
  other: "Otros",
};

// Secciones fijas incluidas en todas las agendas (no personalizables)
export const FIXED_SECTIONS = [
  { name: "Hoja de presentación", pages: 1 },
  { name: "Calendarios Anuales", pages: 2 },
  { name: "Vision Board", pages: 2 },
  { name: "Tracker de Hábitos", pages: 4 },
  { name: "IKIGAI", pages: 2 },
  { name: "Carta a tu yo del futuro", pages: 1 },
  { name: "Carta de agradecimiento a tu yo del pasado", pages: 1 },
  { name: "Rueda de la Vida", pages: 2 },
  { name: "Año en Pixeles", pages: 1 },
  { name: "Inventario de mi Tiempo", pages: 2 },
  { name: "Separadores y hojas adicionales", pages: 4 }, // Para llegar a 22 páginas
];

// Calcular páginas fijas totales
export const FIXED_PAGES_TOTAL = FIXED_SECTIONS.reduce(
  (sum, section) => sum + section.pages,
  0
);

// Sistema de páginas totales
export const MAX_TOTAL_PAGES = 340;

// Constantes legacy (deprecated - usar MAX_TOTAL_PAGES)
export const MIN_SECTIONS = 3;
export const MAX_SECTIONS = 8;
